export const SWIFT_CODE_REGEX = /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/;

export const normalizeSwiftCode = (swiftCode: string): string => swiftCode.toUpperCase().trim();

export const isValidSwiftCode = (swiftCode: string): boolean =>
  SWIFT_CODE_REGEX.test(normalizeSwiftCode(swiftCode));

export const swiftBic8 = (swiftCode: string): string => normalizeSwiftCode(swiftCode).slice(0, 8);
